export const notification = {
    close: {
        label: "Fermer",
        title: "Fermer cette notification"
    }
}